import { authService } from '../auth/auth.service';
import mhdSync from '../mhd/mhdSync';
import { allResources } from 'cross-state';

export default () => {
    return authService.loginState
        .map((state) => state.isLoggedIn)
        .subscribe((isLoggedIn, prevIsLoggedIn) => {
            if (!isLoggedIn && prevIsLoggedIn) {
                setTimeout(() => {
                    mhdSync.clear();
                    allResources.clearAll();
                });
            }
        });
};
